import { useParams } from "react-router-dom";
import { CompaniesPage } from "./CompaniesPage";
import { CompanyDetailPage } from "./CompanyDetailPage";

/** Liste ou fiche détail selon la présence de `:id` (même schéma que les prestataires). */
export function CompaniesPageRouter() {
  const { id } = useParams();
  const companyId = Number(id);

  if (Number.isFinite(companyId) && companyId > 0) {
    return <CompanyDetailPage key={companyId} companyId={companyId} />;
  }

  return <CompaniesPage />;
}
